import React from 'react'
import Centered from './Centered'
import {Flex} from 'rebass'
import {Circle} from 'styled-spinkit'
import {InlineBlock} from "reakit";

export const InlineLoading = (props) => (
	<InlineBlock>
		<Circle size={12}/>
	</InlineBlock>
)
export const FlexLoading = (props) => (
	<Flex {...props}>
		<Circle/>
	</Flex>
)

const Loading = () => (
	<Centered>
		<Circle/>
	</Centered>
);


export default Loading